export enum EnvPreset {
  MORNING_HDR = "MORNING_HDR",
  MORNING = "MORNING",
  MIDDAY = "MIDDAY",
  EVENING = "EVENING",
  WHITEBOX = "WHITEBOX",
  WHITEBOX_LOW_FOG = "WHITEBOX_LOW_FOG",
}
